import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { GetAssetLabels } from "../services/AssetLabels/GetAssetLabels";
import { GetUsers } from "../services/Users/GetUsers";

export const useUsersStore = defineStore("users", () => {
  const users = ref({
    email: "",
    firstName: "",
    id: "",
    lastName: "",
    userTypeId: "",
    isDistributor: false,
    googleSheetLink: null,
    partnerPercentage: "",
    sheetName: null,
    youtube: "",
    twitch: "",
    instagram: "",
    tiktok: "",
    facebook: "",
    twitter: "",
    douyin: "",
    kuaishou: "",
    rumble: "",
    others: "",
    profilePictureUrl: null,
    csCode: "",
    earlyPayEligibility: false,
  });
  const isAdmin = computed(() => {
    return users.value.userTypeId == 1;
  });
  const isSuperAdmin = computed(() => {
    return users.value.userTypeId == 4;
  });
  const isUser = computed(() => {
    return users.value.userTypeId == 2 || users.value.userTypeId == 3;
  });
  const assetLabels = ref([]);
  const assetLabelDataTable = ref({
    columns: [{ label: "Name", field: "name" }],
    rows: [],
  });
  const getUsers = (payload) => {
    getUserById(payload?.UserId).then((response) => {
      users.value = response;
      setIsDistributor(users.value.userTypeId);
    });
  };
  const getUserById = async (id) => {
    const response = await GetUsers(id);
    return response;
  };
  const setIsDistributor = (id) => {
    if (id == 3) users.value.isDistributor = true;
  };
  const getAssetLabels = (payload) => {
    GetAssetLabels(payload?.UserId).then((response) => {
      setSelectedAssetLabels(response.data);
      setDropdownValues();
    });
  };
  const assignedDashboard = ref(1);
  const setSelectedAssetLabels = (selectedArray) => {
    const newArray = selectedArray.map((item) => {
      return {
        ...item,
        selected: true,
        assignedDashboard:
          item.assignedDashboard != null ? item.assignedDashboard : null,
      };
    });
    assetLabels.value = newArray;
  };

  const setDropdownValues = () => {
    assetLabelDataTable.value.rows = assetLabelDataTable.value.rows.map(
      (item) => {
        const item2 = assetLabels.value.find((i2) => {
          if (i2.id == item.id) return i2;
        });
        return item2 ? { ...item, ...item2 } : item;
      }
    );
  };
  return {
    getUsers,
    getUserById,
    users,
    getAssetLabels,
    assetLabels,
    assignedDashboard,
    setDropdownValues,
    assetLabelDataTable,
    isAdmin,
    isUser,
    isSuperAdmin,
  };
});
